import { Link } from 'react-router-dom';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccountMembersV2 } from 'assets/js/pages/account-settings/users/AccountMembersV2';
import { ACCOUNT_MEMBER_ROLES_HELP } from 'constants/links';
import { useAccountMemberRoles } from 'customHooks/useAccountMemberRoles';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const UserSettingsV2 = () => {
    const { accountId } = useCurrentAccount();
    const { data: roles } = useAccountMemberRoles();

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center">
                <div className="flex-grow flex-col">
                    <div className="text-xl font-medium text-black">Users</div>
                    <p>
                        For more information on specific roles and how to manage them,{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://help.givebutter.com/en/articles/2118934-how-to-manage-account-users"
                        >
                            read our guide.
                        </a>
                    </p>
                </div>
                <div className="center">
                    <Link to={`/accounts/${accountId}/settings/users/invite`}>
                        <Button variant="solid" size="md">
                            <FontAwesomeIcon icon={faPlus} />
                            Invite users
                        </Button>
                    </Link>
                </div>
            </div>
            <AccountMembersV2 />
            <Box className="p-6">
                <div className="flex flex-col gap-4">
                    <p className="text-lg font-medium text-gray-900">About roles & permissions</p>
                    <div className="flex flex-col gap-6">
                        <div className="grid grid-cols-2 gap-6">
                            {roles.data.map(role => (
                                <div key={role.name} className="flex flex-col gap-1">
                                    <p className="text-sm font-medium text-gray-700">{role.name}</p>
                                    <p className="text-sm text-gray-600">{role.description}</p>
                                </div>
                            ))}
                        </div>
                        <div className="flex flex-col gap-4 rounded bg-gray-100 p-4">
                            <div>
                                <div className="text-sm font-medium text-gray-700">
                                    Need more info around roles and permissions?
                                </div>
                                <div className="text-sm text-gray-700">
                                    Visit our Help Center for detailed information on inviting
                                    people, managing roles and permissions, and making the most of
                                    these features within your organization.
                                </div>
                            </div>
                            <div>
                                <a
                                    href={ACCOUNT_MEMBER_ROLES_HELP}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button size="sm" variant="outline">
                                        View help center
                                    </Button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        </div>
    );
};

export { UserSettingsV2 };
